import React, { createContext, useEffect, type ReactNode } from "react";
import { useAuth } from "@/hooks/api";
import { useOrganizationStore } from "@/stores/organizationStore";
import type { User } from "@/types";

interface AuthContextType {
  user: User | null | undefined;
  isLoading: boolean;
  isError: boolean;
  isAuthenticated: boolean;
  stytchLogin: (sessionToken: string, sessionJwt?: string) => Promise<unknown>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const auth = useAuth();

  // Select the org/label or payee as soon as the user is known, above the router,
  // so routing never depends on a layout component having mounted.
  const initFromUser = useOrganizationStore((s) => s.initFromUser);
  useEffect(() => {
    initFromUser(auth.user);
  }, [auth.user, initFromUser]);

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};
